<template>
  <span v-if="showUpdating" :data-important-tooltip="$t('refreshing')">
    {{ $t('updating') }}
  </span>
  <span v-else-if="showEmptyValue" :data-important-tooltip="$t(tooltipSentence)" class="empty-value">&mdash;</span>
  <span v-else>{{ showValue }}</span>
</template>

<script>
import { KEYWORD_TYPES } from '@/constants';
import { mapGetters } from 'vuex';

export default {
  name: 'SearchDetailRenderer',
  computed: {
    ...mapGetters(['getProjectByProjectId', 'getDisplaySetting', 'getCurrencyByCode']),
    showUpdating() {
      if (this.params.column.colId === 'seocomp' && this.getValue === -1) {
        // -1 indicates the there were no results found
        // false indicates that the updaing has completed
        return false;
      }
      return this.getValue === null;
    },
    getValue() {
      return this.params.column.colId === 'searchvolume' ? this.params.data.ms : this.params.value;
    },
    tooltipSentence() {
      if (this.getValue === -1 && this.params.column.colId === 'seocomp') {
        // Currently the search result is not available when we scrape mobile device
        if (this.params.data.type === KEYWORD_TYPES.mobile) {
          return 'columns.seocomp.tooltip';
        } else {
          return 'columns.seocomp.noDataFound';
        }
      }
      return 'not-changed-data';
    },
    showEmptyValue() {
      // -1 indicates the there were no results found
      if (this.params.column.colId === 'seocomp') {
        return this.getValue === -1;
      }
      return this.getValue === 0 && this.params.column.colId !== 'competition';
    },
    showValue() {
      switch (this.params.column.colId) {
        case 'competition':
          return this.params.value < 0.35
            ? this.$t('low')
            : this.params.value < 0.7
              ? this.$t('medium')
              : this.$t('high');
        case 'cpc':
          return `${decodeURIComponent(this.params.data.currency_symbol)} ${this.params.value.toFixed(2)}`;
        case 'searchvolume':
          return this.params.data.ms.toLocaleString('en');
        case 'seocomp':
          return this.params.value.toLocaleString('en');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
